import {Component,  Prop, Vue, Model } from 'vue-property-decorator';
@Component
export default class CancelOrderDialog extends Vue {
  @Prop({type: Number })
  public orderNo!: number;

  @Model('changeDialog',{
    type: Boolean
  })
  public isCancel!: boolean;
  public cancelReason: string = '0';                                        //  取消原因
  public cancelFlag: boolean = false;                                       //  取消失败开关

  //  关闭dialog
  public closeDialog(isUpdate?: boolean) {
    this.cancelReason = '0';
    this.cancelFlag = false;
    this.$emit('changeDialog' , false);
    Object.prototype.toString.call(isUpdate) === '[object Boolean]' && this.$emit('canceled');
  }
  //  取消订单
  public confirmCancel() {
    if (this.cancelReason === '0') {
      this.cancelFlag = true;
      return;
    }
    this.fetch({
      url: window.apis.cancelOrder,
      data: {
        orderId: this.orderNo,
        note: this.cancelReason,
        channel: 1
      }
    }).then(() => {
      this.closeDialog(true);
    });
  }
}
